import React from "react";
import { Box } from "@chakra-ui/react";
import { ChakraBox } from "ui/chakra-framer";
import { type AccordionButtonProps } from "./accordion-button";

export function ProgressBar({ label, isInView, animationDuration }: AccordionButtonProps) {
  return (
    <>
      <Box pos="absolute" bg="base.divider" h={1.5} top={{ base: -7, xl: -10 }} left={0} right={0} />
      <ChakraBox
        key={label}
        pos="absolute"
        bg={isInView ? "grassDark" : "none"}
        h={1.5}
        top={{ base: -7, xl: -10 }}
        zIndex={1}
        initial={{ width: 0 }}
        animate={{ width: "100%", transition: { ease: "linear", duration: animationDuration } }}
      />
    </>
  );
}
